"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simplifyContext = exports.isUrlActive = exports.handleClick = exports.findSubMenus = exports.default = exports.classOpen = exports.Target = exports.CleanUrl = void 0;
var _react = _interopRequireWildcard(require("react"));
var _config = require("webmotors-react-pj/config");
var _v = _interopRequireDefault(require("webmotors-react-pj/tag-analytics/v2"));
var _utils = require("webmotors-react-pj/utils");
var _style = require("webmotors-react-pj/frame/menu/items/style");
var _badge = require("@webmotors/eleanor-ui/webmotors/badge");
var _context = _interopRequireDefault(require("../context"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const classOpen = exports.classOpen = 'cockpit-menu-open';
const Target = url => /(autoguru)\.|webmotors|zendesk\.com|\/universidade$|ajuda./.test(url) ? '_blank' : '_self';
exports.Target = Target;
const simplifyContext = url => {
  const urlParsed = new URL(url);
  const {
    pathname
  } = urlParsed;
  const pathContextArr = pathname.split('/');
  if (pathContextArr.length > 2) {
    pathContextArr.pop();
  }
  const pathContextClean = pathContextArr.join('/');
  return pathContextClean;
};
exports.simplifyContext = simplifyContext;
const CleanUrl = url => url.replace(/#.*$/, '');
exports.CleanUrl = CleanUrl;
const isUrlActive = (item, CleanUrl, simplifyContext) => {
  const activeUrl = window.location.href;
  const cleanActiveUrl = CleanUrl(activeUrl);
  return cleanActiveUrl === CleanUrl(item.url) || item.subMenu.some(i => {
    const cleanUrl = CleanUrl(i.url);
    return cleanActiveUrl === cleanUrl || simplifyContext(cleanActiveUrl) === simplifyContext(cleanUrl);
  });
};
exports.isUrlActive = isUrlActive;
const findSubMenus = target => {
  var _target$nextElementSi, _target$nextElementSi2, _target$parentElement, _target$parentElement2, _target$parentElement3, _target$nextElementSi3, _target$nextElementSi4;
  if (((_target$nextElementSi = target.nextElementSibling) === null || _target$nextElementSi === void 0 ? void 0 : (_target$nextElementSi2 = _target$nextElementSi.tagName) === null || _target$nextElementSi2 === void 0 ? void 0 : _target$nextElementSi2.toLowerCase()) !== 'ul' && ((_target$parentElement = target.parentElement) === null || _target$parentElement === void 0 ? void 0 : (_target$parentElement2 = _target$parentElement.nextElementSibling) === null || _target$parentElement2 === void 0 ? void 0 : (_target$parentElement3 = _target$parentElement2.tagName) === null || _target$parentElement3 === void 0 ? void 0 : _target$parentElement3.toLowerCase()) !== 'ul') return target.parentElement.nextElementSibling.parentElement.nextElementSibling;
  if (((_target$nextElementSi3 = target.nextElementSibling) === null || _target$nextElementSi3 === void 0 ? void 0 : (_target$nextElementSi4 = _target$nextElementSi3.tagName) === null || _target$nextElementSi4 === void 0 ? void 0 : _target$nextElementSi4.toLowerCase()) !== 'ul') return target.parentElement.nextElementSibling;else return target.nextElementSibling;
};
exports.findSubMenus = findSubMenus;
const handleClick = (event, tracking, notification, onModal, onModalStore, onRedirect, url, arrowRef) => {
  const modalLinkBlock = ['/termos/pendentes', '/my-plan/invoice', '/my-plan/plan', '/terms/pending', '/reports/calls', '/reports/call-details', '/reports/leads-alerts', '/reports/car-details', '/reports/details-new', '/reports/details-used'];
  const path = url === "#" ? '' : new URL(url).pathname;
  const {
    idGrupo,
    unique_name: uniqueName
  } = (0, _utils.jwtGet)();
  const {
    target
  } = event;
  const nextElementSibling = findSubMenus(target);
  const groupIs = idGrupo && idGrupo !== '0';
  const modalShow = uniqueName === '0' && modalLinkBlock.includes(path) && groupIs;
  if (notification.type === "modal") {
    onModal();
  }
  ;
  if (notification.type !== "modal" && modalShow) {
    onRedirect(target.href);
    onModalStore();
  }
  if (nextElementSibling) {
    const classAnimation = 'cockpit-menu-animation';
    const submenuClose = item => {
      const element = item;
      Object.values(element)[0].type != 'div' && (element.style.height = '0px');
      element.classList.remove(classOpen);
      element.addEventListener('transitionend', () => {
        element.classList.remove(classAnimation);
        element.removeAttribute('style');
      }, {
        once: true
      });
    };
    const isOpen = nextElementSibling.classList.contains(classOpen);
    [...document.querySelectorAll(".".concat(classOpen))].forEach(item => submenuClose(item));
    if (!isOpen) {
      nextElementSibling.classList.add(classOpen);
      const {
        clientHeight
      } = nextElementSibling;
      nextElementSibling.classList.remove(classOpen);
      arrowRef.current.classList.add(classOpen);
      nextElementSibling.classList.add(classAnimation);
      setTimeout(() => {
        nextElementSibling.style.height = "".concat(clientHeight, "px");
        nextElementSibling.classList.add(classOpen);
      }, 10);
    } else {
      arrowRef.current.classList.remove(classOpen);
    }
  }
  if (tracking) {
    (0, _v.default)(tracking, {
      site: {
        subEnvironment: 'homepage'
      },
      page: {
        flowType: 'cockpit',
        pageType: 'cockpit-homepage',
        pageName: '/webmotors/cockpit/homepage',
        'pageName.tier1': 'cockpit',
        'pageName.tier2': 'homepage',
        'pageName.tier3': undefined,
        loadTime: window.performance.PerformanceNavigationTiming
      }
    });
  }
};
exports.handleClick = handleClick;
const replaceSpaceToHiphen = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.toLowerCase().replace(/\s+/g, '-');
};
const removeAccents = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
var _default = _ref => {
  let {
    children,
    onModal,
    onModalStore,
    onRedirect
  } = _ref;
  const {
    get: {
      pinnedMenu,
      showPin
    }
  } = (0, _react.useContext)(_context.default);
  const arrowRef = (0, _react.useRef)();
  const Icon = param => param && _react.default.createElement(_style.StyleImg, {
    src: "".concat(_config.UrlCockpit, "/assets/img/icons").concat(param),
    alt: "",
    "aria-hidden": "true"
  });
  const returnClassOpenedMenu = menuToCheck => isUrlActive(menuToCheck, CleanUrl, simplifyContext) && pinnedMenu && showPin ? classOpen : '';
  const notificationPending = _ref2 => {
    let {
      type = 'number',
      text,
      command = 'termsPending'
    } = _ref2;
    const handleTermPending = () => {
      const {
        cockpitStorageTerm
      } = window.localStorage;
      if (cockpitStorageTerm) {
        const pendingId = 65;
        const termsJSON = JSON.parse(cockpitStorageTerm);
        const [termsPending] = termsJSON.term_status.filter(item => item.id === pendingId);
        if (termsPending) {
          const {
            length
          } = termsPending.categories.flatMap(item => item.terms);
          const quantityTerms = length > 100 ? '+99' : length;
          return type === 'number' ? quantityTerms : text;
        }
        return '';
      }
      return '';
    };
    const handleReturnBadge = () => text;
    const literalRenderFunction = {
      'termsPending': handleTermPending(),
      'badge': handleReturnBadge()
    };
    return literalRenderFunction[command];
  };
  const MenuItem = _ref3 => {
    let {
      children: child
    } = _ref3;
    const {
      subMenu: sub = [],
      url,
      icone: icon,
      menu: name,
      notification = false,
      key,
      tracking = false
    } = child;
    const notificationText = notification && notificationPending({
      type: notification.type,
      text: notification.text,
      command: notification.command
    });
    return _react.default.createElement("li", null, _react.default.createElement(_style.StyleLink, {
      onClick: e => {
        if (!sub.length) window.open(url, Target(url));else {
          handleClick(e, tracking, notification, onModal, onModalStore, onRedirect, url, arrowRef);
        }
      }
    }, _react.default.createElement(_style.StyleFlex, null, isUrlActive({
      url,
      subMenu: sub
    }, CleanUrl, simplifyContext) && !Boolean(sub.length) && _react.default.createElement(_style.StyleRedLine, {
      pinnedMenu: pinnedMenu,
      showPin: showPin
    }), Icon(icon), _react.default.createElement(_style.StyleName, {
      id: replaceSpaceToHiphen(removeAccents(name)),
      pinnedMenu: pinnedMenu,
      showPin: showPin
    }, name), (pinnedMenu || showPin) && notificationText && _react.default.createElement(_style.StyleNotification, null, _react.default.createElement(_badge.Badge, {
      size: "small",
      variant: "complementary",
      text: notificationText
    }))), !!sub.length && _react.default.createElement(_style.StyleArrow, {
      ref: arrowRef,
      pinnedMenu: pinnedMenu,
      showPin: showPin
    })), Boolean(sub.length) && _react.default.createElement(_style.StyleSublist, {
      className: returnClassOpenedMenu(child)
    }, sub.map(item => _react.default.createElement(MenuItem, {
      key: item.key
    }, item))));
  };
  return _react.default.createElement(MenuItem, null, children);
};
exports.default = _default;